import { hashKey, useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { queryClient, trpc } from "../../app/trpc.js";
import { dropDevicePush } from "./device-push.js";

/**
 * Выход из профиля, один для «Ещё» в кабинете и для админки.
 * Общий телефон в салоне: перед выходом снимаем push-подписку устройства, чтобы уведомления прошлого
 * мастера не приходили следующему. После выхода кэш запросов очищается целиком (салоны, диалоги, уведомления),
 * а `auth.me` сразу становится null: защищённые маршруты уводят на вход, следующий вошедший чужих данных не видит.
 * Если выход не удался, кнопка снова доступна, а ошибка отдаётся наружу для Notice.
 */
export function useLogout(): { logout: () => Promise<void>; pending: boolean; error: { message: string } | null } {
  const [leaving, setLeaving] = useState(false);
  const logoutM = useMutation(
    trpc.auth.logout.mutationOptions({
      onSuccess: () => {
        const meKey = trpc.auth.me.queryKey();
        const meHash = hashKey(meKey);
        queryClient.setQueryData(meKey, null);
        queryClient.removeQueries({ predicate: (q) => q.queryHash !== meHash });
      },
      onError: () => setLeaving(false),
    }),
  );
  const dropPush = useMutation(trpc.cabinet.push.unsubscribe.mutationOptions());
  const logout = async () => {
    setLeaving(true);
    try {
      const endpoint = await dropDevicePush();
      if (endpoint) await dropPush.mutateAsync({ endpoint });
    } catch {
      // подписку снять не вышло, всё равно выходим
    }
    logoutM.mutate();
  };
  return { logout, pending: leaving || logoutM.isPending, error: logoutM.error };
}
